import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useRef } from 'react';
import ProductGallery from './ProductsAndStyle/ProductGallery';
import StyleGallery from './ProductsAndStyle/StyleGallery';
import CreateSidebar from './CreateSidebar/CreateSidebar';
import EditSidebar from './EditSidebar/EditSidebar';
import { useImage } from '../../context/ImageContext';
import { check_job_status } from '../../utils/utilities';

const Sidebar = ({
  editUploadedImages,
  setEditUploadedImages,
  brushSize,
  setBrushSize,
  eraserSize,
  setEraserSize,
  activeButton,
  setActiveButton,
  selectedProduct,
  setSelectedProduct,
  fetchAllCreateHistory,
  fetchAllEditHistory,
  setAllCreateHistory,
  setAllEditHistory,
  allCreateHistory,
  allEditHistory,
  setAllBGHCreateHistory,
  allBGHCreateHistory,
  setCreditsAvailable,
  setSelectedEditGroup,
  setCreatePageNumber,
  setEditPageNumber,
  setBghPageNumber,
}) => {

  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isStyleModalOpen, setIsStyleModalOpen] = useState(false);
  const [createEstTime, setCreateEstTime] = useState(0);
  const [editEstTime, setEditEstTime] = useState(0);
  const [bghEstTime, setBghEstTime] = useState(0);
  const [selectedBghGroup, setSelectedBghGroup] = useState(null);

  const [progressCreate, setProgressCreate] = useState(createEstTime);
  const [progressEdit, setProgressEdit] = useState(editEstTime);
  const [progressBgh, setProgressBgh] = useState(bghEstTime);
  const [jobResponseCreate, setJobResponseCreate] = useState({});
  const [jobResponseEdit, setJobResponseEdit] = useState({});
  const [jobResponseBgh, setJobResponseBgh] = useState({});

  // BGH refs
  const BGHcreateContainerRef = useRef(null);
  const BGHcreateImageRef = useRef(null);
  const [BGHmaxstyle, setBGHmaxstyle] = useState(false);
  const [bghAdjustDropdownIsOpen, setBghAdjustDropdownIsOpen] = useState(false);
  const [BGHselectedProduct, setBGHSelectedProduct] = useState({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Product Image", "refNum": null });
  const [BGHCreativeControlValue, setBGHCreativeControlValue] = useState(1);
  const [BGHselectedStyle, setBGHSelectedStyle] = useState({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Style" });
  const [BGHcreatePrompt, setBGHCreatePrompt] = useState("Product in a modern living room with neutral tones, wooden flooring, and soft natural light coming through large windows. Everything is clean, cozy, and magazine-ready");
  const [BGHcreateLoadingCircle, setBGHCreateLoadingCircle] = useState(false);
  const [BGHcreateRefNum, setBGHCreateRefNum] = useState(5);
  const [BGHcreateRandomize, setBGHCreateRandomize] = useState(true);
  const [BGHcreateNumberOfImages, setBGHCreateNumberOfImages] = useState(4);
  const [bghCreateControlOptions, setBghCreateControlOptions] = useState([
    { value: 0, label: "Minimal", description: "Keep original lighting & orientation; build scene around it. " },
    { value: 1, label: "Moderate", description: "Relight to match scene—adds creative flair (recommended)" }
  ]);



  const [CreativeControlValue, setCreativeControlValue] = useState(1);
  const [selectedStyle, setSelectedStyle] = useState({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Style" });
  const [createPrompt, setCreatePrompt] = useState("Product in a modern living room with neutral tones, wooden flooring, and soft natural light coming through large windows. Everything is clean, cozy, and magazine-ready");
  const [createLoadingCircle, setCreateLoadingCircle] = useState(false);
  const createContainerRef = useRef(null);
  const createImageRef = useRef(null);
  const [createRefNum, setCreateRefNum] = useState(5);
  const [createRandomize, setCreateRandomize] = useState(true);
  const [createNumberOfImages, setCreateNumberOfImages] = useState(4);
  const [maxstyle, setMaxstyle] = useState(false);
  const [createAdjustDropdownIsOpen, setCreateAdjustDropdownIsOpen] = useState(false);
  const [createControlOptions, setCreateControlOptions] = useState([
    { value: 0, label: "Enhanced", description: "Works best for simpler and big products - more artistic" },
    { value: 1, label: "Mode 2", description: "Closely adheres to the prompt - preserves product better (recommended)" }
  ]);

  const [editSelectedProduct, setEditSelectedProduct] = useState({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Product Image" });
  const [inputValue, setInputValue] = useState(20);
  const [selectedAction, setSelectedAction] = useState('add');
  const [accessoryImage, setAccessoryImage] = useState(null);
  const [editPrompt, setEditPrompt] = useState('');
  const [editNumberOfImages, setEditNumberOfImages] = useState('1');
  const [editLoadingCircle, setEditLoadingCircle] = useState(false);
  const [editRefNum, setEditRefNum] = useState(5);
  const [editCreateControlOptions, setEditCreateControlOptions] = useState([
    { value: 0, label: "API 1", description: "Works best for text-based edits - Mask and prompt. " },
    { value: 1, label: "API 2", description: "Use for replacing or adding specific objects or products - Mask and select image" }
  ]);

  // Create Loading Bar...............
  const intervalRef = useRef(null);
  useEffect(() => {
    setProgressCreate(createEstTime);
  }, [createEstTime]);

  useEffect(() => {
    if (progressCreate > 0) {
      intervalRef.current = setInterval(() => {
        setProgressCreate((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            return 0;
          }
          // else if (check_job_status(jobResponseCreate) === 0) {
          //   // if (Object.keys(jobResponseCreate).length !== 0) 
          //   return 0;
          // }

          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      // console.log("Fetching create history......");
      setAllCreateHistory([]);
      setCreatePageNumber(0);
      fetchAllCreateHistory(allCreateHistory, setAllCreateHistory, 0, 'all_createPage')

      setCreateEstTime(0);
    }
    return () => clearInterval(intervalRef.current); // Cleanup on unmount or dependency change
  }, [progressCreate]);

  // Edit Loading Bar...............
  const intervalRef2 = useRef(null);
  useEffect(() => {
    setProgressEdit(editEstTime);
  }, [editEstTime]);

  useEffect(() => {
    if (progressEdit > 0) {
      intervalRef2.current = setInterval(() => {
        setProgressEdit((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef.current);
            return 0;
          }
          // else if (check_job_status(jobResponseEdit) === 0) {
          //   // if (Object.keys(jobResponseEdit).length !== 0) 
          //   return 0;
          // }

          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
      // console.log("Fetching edit history......");
      setAllEditHistory([]);
      setEditPageNumber(0);
      fetchAllEditHistory(allEditHistory, setAllEditHistory, 0)
      setEditEstTime(0);
    }
    return () => clearInterval(intervalRef2.current); // Cleanup on unmount or dependency change
  }, [progressEdit]);

  // BGH Loading Bar
  const intervalRef3 = useRef(null);
  useEffect(() => {
    setProgressBgh(bghEstTime);
  }, [bghEstTime]);

  useEffect(() => {
    if (progressBgh > 0) {
      intervalRef3.current = setInterval(() => {
        setProgressBgh((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalRef3.current);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    } else {
      clearInterval(intervalRef3.current);
      setAllBGHCreateHistory([]);
      setBghPageNumber(0);
      fetchAllCreateHistory(allBGHCreateHistory, setAllBGHCreateHistory, 0, 'all_bghPage')
      setBghEstTime(0);
    }
    return () => clearInterval(intervalRef3.current);
  }, [progressBgh]);

  const { activeTab, setActiveTab } = useImage();
  const [hoveredTab, setHoveredTab] = useState(null);
  const [hoveredTabRect, setHoveredTabRect] = useState(null);
  const [sidebarRect, setSidebarRect] = useState(null);
  const headerHoverText = {
    bgh: "Generate a photorealistic backdrop around the product—product angle stays fixed",
    create: "Create new scenes, perspectives, and angles while the product's remains unchanged.",
    edit:"Erase, add, recolor, or swap product or object to refine any part of the image.",
  };



  // Helper to get tab element and set rect
  const handleTabMouseEnter = (tab, e) => {
    setHoveredTab(tab);
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setHoveredTabRect(rect);
      // Get sidebar rect
      const sidebar = document.querySelector('aside');
      if (sidebar) {
        setSidebarRect(sidebar.getBoundingClientRect());
      }
    }
  };
  const handleTabMouseLeave = () => {
    setHoveredTab(null);
    setHoveredTabRect(null);
  };

  return (
    <aside className="w-full lg:w-1/4 min-h-screen mt-16 bg-white border-r border-gray-200 relative" >
      <div className="fixed w-full lg:w-1/4 bg-white z-10 border-b border-gray-200 shadow-sm">
        <div className="flex w-full">
          {/* BGH Tab */}
          <div
            className={`flex items-center justify-center cursor-pointer w-1/3 py-4 transition-all duration-150 ${activeTab === 'bgh'
              ? 'text-purple-600 border-b-2 border-purple-600'
              : 'text-gray-500 hover:text-purple-500 hover:border-b-2 hover:border-purple-200'
              }`}
            onClick={() => setActiveTab('bgh')}
            onMouseEnter={e => handleTabMouseEnter('bgh', e)}
            onMouseLeave={handleTabMouseLeave}
            style={{ position: 'relative' }}
          >
            <div className="flex items-center space-x-2">
              <i className="fas fa-image text-lg lg:text-xl"></i>
              <span className="font-medium text-sm lg:text-base">Backdrop</span>
            </div>
          </div>

          {/* Create Tab */}
          <div
            className={`flex items-center justify-center cursor-pointer w-1/3 py-4 transition-all duration-150 ${activeTab === 'create'
              ? 'text-purple-600 border-b-2 border-purple-600'
              : 'text-gray-500 hover:text-purple-500 hover:border-b-2 hover:border-purple-200'
              }`}
            onClick={() => setActiveTab('create')}
            onMouseEnter={e => handleTabMouseEnter('create', e)}
            onMouseLeave={handleTabMouseLeave}
            style={{ position: 'relative' }}
          >
            <div className="flex items-center space-x-2">
              <i className="fas fa-magic text-lg lg:text-xl"></i>
              <span className="font-medium text-sm lg:text-base">Reframe</span>
            </div>
          </div>

          {/* Edit Tab */}
          <div
            className={`flex items-center justify-center cursor-pointer w-1/3 py-4 transition-all duration-150 ${activeTab === 'edit'
              ? 'text-purple-600 border-b-2 border-purple-600'
              : 'text-gray-500 hover:text-purple-500 hover:border-b-2 hover:border-purple-200'
              }`}
            onClick={() => setActiveTab('edit')}
            onMouseEnter={e => handleTabMouseEnter('edit', e)}
            onMouseLeave={handleTabMouseLeave}
            style={{ position: 'relative' }}
          >
            <div className="flex items-center space-x-2">
              <i className="fas fa-edit text-lg lg:text-xl"></i>
              <span className="font-medium text-sm lg:text-base">Retouch</span>
            </div>
          </div>
        </div>
        {/* Tooltip rendered outside the tab containers to avoid clipping */}
        {hoveredTab && hoveredTabRect && sidebarRect && (
          (() => {
            // Calculate tooltip width and padding
            const tooltipWidth = 280; // Fixed width for the tooltip
            const tooltipPadding = 16; // Padding on each side
            
            // Calculate the center point of the tab
            const tabCenter = hoveredTabRect.left + (hoveredTabRect.width / 2);
            
            // Calculate the maximum allowed left position
            const maxLeft = window.innerWidth - tooltipWidth - tooltipPadding;
            
            // Calculate the initial left position
            let left = tabCenter - (tooltipWidth / 2);
            
            // Adjust position if tooltip would go off screen
            if (left < tooltipPadding) {
              left = tooltipPadding;
            } else if (left > maxLeft) {
              left = maxLeft;
            }
            
            return (
              <div
                className="fixed z-[9999] pointer-events-none animate-fadein"
                style={{
                  left: left,
                  top: hoveredTabRect.bottom - sidebarRect.top + sidebarRect.top + 8, // 8px below the tab
                  width: tooltipWidth,
                }}
              >
                <div
                  className="flex items-start gap-2 px-4 py-3 text-xs font-medium rounded-lg border shadow-md bg-white"
                  style={{
                    borderColor: '#a78bfa', // soft purple
                    color: '#23272f',
                    boxShadow: '0 2px 12px 0 rgba(124,58,237,0.08)',
                    fontSize: '0.93rem',
                    whiteSpace: 'normal', // Allow text to wrap
                    lineHeight: '1.4', // Improve readability of wrapped text
                  }}
                >
                  <span style={{ fontSize: '1.1em', color: '#a78bfa', marginTop: '0.1em' }}>💜</span>
                  <span>{headerHoverText[hoveredTab]}</span>
                </div>
              </div>
            );
          })()
        )}
      </div>

      <div className="mt-16 p-4 lg:p-6 pb-24 ">
        {activeTab === 'bgh' ? (
          <CreateSidebar
            selectedProduct={BGHselectedProduct}
            setSelectedProduct={setBGHSelectedProduct}
            createEstTime={bghEstTime}
            setCreateEstTime={setBghEstTime}
            setJobResponseCreate={setJobResponseBgh}
            progressCreate={progressBgh}
            setCreditsAvailable={setCreditsAvailable}
            value={BGHCreativeControlValue}
            setValue={setBGHCreativeControlValue}
            selectedStyle={BGHselectedStyle}
            setSelectedStyle={setBGHSelectedStyle}
            prompt={BGHcreatePrompt}
            setPrompt={setBGHCreatePrompt}
            loadingCircle={BGHcreateLoadingCircle}
            setLoadingCircle={setBGHCreateLoadingCircle}
            containerRef={BGHcreateContainerRef}
            imageRef={BGHcreateImageRef}
            refNum={BGHcreateRefNum}
            randomize={BGHcreateRandomize}
            numberOfImages={BGHcreateNumberOfImages}
            setRefNum={setBGHCreateRefNum}
            setRandomize={setBGHCreateRandomize}
            setNumberOfImages={setBGHCreateNumberOfImages}
            maxstyle={BGHmaxstyle}
            setMaxstyle={setBGHmaxstyle}
            adjustDropdownIsOpen={bghAdjustDropdownIsOpen}
            setAdjustDropdownIsOpen={setBghAdjustDropdownIsOpen}
            options={bghCreateControlOptions}
          />
        ) : activeTab === 'create' ? (
          <CreateSidebar
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            createEstTime={createEstTime}
            setCreateEstTime={setCreateEstTime}
            setJobResponseCreate={setJobResponseCreate}
            progressCreate={progressCreate}
            setCreditsAvailable={setCreditsAvailable}
            value={CreativeControlValue}
            setValue={setCreativeControlValue}
            selectedStyle={selectedStyle}
            setSelectedStyle={setSelectedStyle}
            prompt={createPrompt}
            setPrompt={setCreatePrompt}
            loadingCircle={createLoadingCircle}
            setLoadingCircle={setCreateLoadingCircle}
            containerRef={createContainerRef}
            imageRef={createImageRef}
            refNum={createRefNum}
            randomize={createRandomize}
            numberOfImages={createNumberOfImages}
            setRefNum={setCreateRefNum}
            setRandomize={setCreateRandomize}
            setNumberOfImages={setCreateNumberOfImages}
            maxstyle={maxstyle}
            setMaxstyle={setMaxstyle}
            adjustDropdownIsOpen={createAdjustDropdownIsOpen}
            setAdjustDropdownIsOpen={setCreateAdjustDropdownIsOpen}
            options={createControlOptions}
          />
        ) : (
          <EditSidebar
            editUploadedImages={editUploadedImages}
            setEditUploadedImages={setEditUploadedImages}
            brushSize={brushSize}
            setBrushSize={setBrushSize}
            eraserSize={eraserSize}
            setEraserSize={setEraserSize}
            activeButton={activeButton}
            setActiveButton={setActiveButton}
            editEstTime={editEstTime}
            setEditEstTime={setEditEstTime}
            setJobResponseEdit={setJobResponseEdit}
            progressEdit={progressEdit}
            setCreditsAvailable={setCreditsAvailable}
            setSelectedEditGroup={setSelectedEditGroup}
            selectedAction={selectedAction}
            setSelectedAction={setSelectedAction}
            selectedProduct={editSelectedProduct}
            setSelectedProduct={setEditSelectedProduct}
            inputValue={inputValue}
            setInputValue={setInputValue}
            accessoryImage={accessoryImage}
            setAccessoryImage={setAccessoryImage}
            prompt={editPrompt}
            setPrompt={setEditPrompt}
            loadingCircle={editLoadingCircle}
            setLoadingCircle={setEditLoadingCircle}
            refNum={editRefNum}
            setRefNum={setEditRefNum}
            numberOfImages={editNumberOfImages}
            setNumberOfImages={setEditNumberOfImages}
            options={editCreateControlOptions}
          />
        )}
      </div>


    </aside>
  );
};

export default Sidebar;